<template>
  <div class="compass-view">
    <div class="weather-info">
      <div>
        <i class="el-icon-sunny" style="margin-right: 5px"></i>
        {{ $t('温度') }} {{ weatherMsg.temp }}°
      </div>
      <div style="margin: 5px 0">
        <i class="el-icon-heavy-rain" style="margin-right: 5px"></i>
        {{ $t('湿度') }} {{ weatherMsg.humidity }}%
      </div>
      <div>
        <i class="el-icon-wind-power" style="margin-right: 5px"></i>
        {{ $t('风力') }} {{ windLevel }}级
      </div>
    </div>
    <v-chart
      ref="mychart"
      :options="options"
      style="height: 100px !important; width: 100px !important"
      :autoresize="true"
    ></v-chart>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import { isEmpty } from '@/utils/is';

export default {
  props: {
    weatheInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('app', ['theme'])
  },
  watch: {
    theme() {
      this.setChartTheme();
    },
    weatheInfo: {
      handler(newVal) {
        this.setChartHandler(newVal);
      },
      deep: true
    }
  },
  data() {
    return {
      showChart: false,
      weatherMsg: {
        temp: '-',
        humidity: '-'
      },
      windLevel: '0',

      options: {
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%'
        },
        series: [
          {
            name: '指南针',
            type: 'gauge',
            clockWise: true,
            startAngle: 90,
            endAngle: 450,
            min: 0,
            max: 360,
            splitNumber: 4,
            axisTick: {
              splitNumber: 13,
              length: 8,
              lineStyle: {
                color: 'rgba(255, 255, 255, 1)'
              }
            },
            splitLine: {
              show: false
            },
            axisLine: { show: false },
            axisLabel: {
              show: true,
              distance: -18,
              fontSize: 10,
              color: 'rgba(255, 255, 255, 1)',
              formatter: value => {
                const directions = ['N', 'W', 'S', 'E'];
                const index = value / 90; // 计算当前值对应的方向索引，考虑ECharts的0度在右侧，需要调整

                return directions[index];
              }
            },
            detail: {
              show: false,
              textStyle: {
                color: 'auto',
                fontSize: 12,
                fontWeight: 'bolder'
              },
              offsetCenter: [0, 0],
              formatter: value => {
                const directions = ['北', '东北', '西', '西南', '南', '东南', '东', '东北'];
                const index = Math.floor((value + 22.5) / 45) % 8; // 计算当前值对应的方向索引，考虑ECharts的0度在右侧，需要调整

                return directions[index];
              }
            },
            anchor: {
              show: false,
              showAbove: false,
              size: 15,
              itemStyle: {
                borderWidth: 0
              }
            },
            pointer: {
              width: '5%',
              length: '50%',
              itemStyle: {
                color: 'red'
              }
            },
            data: [
              {
                value: 0
                //name: '西风'
              }
            ]
          }
        ]
      }
    };
  },
  mounted() {
    this.options = {
      tooltip: {
        formatter: '{a} <br/>{b} : {c}%'
      },
      series: [
        {
          name: '指南针',
          type: 'gauge',
          clockWise: true,
          startAngle: 90,
          endAngle: 450,
          min: 0,
          max: 360,
          splitNumber: 4,
          axisTick: {
            splitNumber: 13,
            length: 8,
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)'
            }
          },
          splitLine: {
            show: false
          },
          axisLine: { show: false },
          axisLabel: {
            show: true,
            color: 'rgba(255, 255, 255, 1)',
            distance: -18,
            fontSize: 10,
            formatter: value => {
              const directions = ['N', 'W', 'S', 'E'];
              const index = value / 90; // 计算当前值对应的方向索引，考虑ECharts的0度在右侧，需要调整

              return directions[index];
            }
          },
          detail: {
            show: true,
            textStyle: {
              //color: 'auto',
              color: 'rgba(255, 255, 255, 1)',
              fontSize: 12,
              fontWeight: 'bolder'
            },
            offsetCenter: [0, 0],
            formatter: value => {
              const directions = ['北', '东北', '西', '西南', '南', '东南', '东', '东北'];
              const index = Math.floor((value + 22.5) / 45) % 8; // 计算当前值对应的方向索引，考虑ECharts的0度在右侧，需要调整

              return directions[index];
            }
          },
          anchor: {
            show: false,
            showAbove: false,
            size: 15,
            itemStyle: {
              borderWidth: 0
            }
          },
          pointer: {
            width: '5%',
            length: '50%',
            itemStyle: {
              color: 'rgba(255, 255, 255, 1)'
            }
          },
          data: [
            {
              value: 0
              //name: '西风'
            }
          ]
        }
      ]
    };

    this.setChartTheme();
  },
  methods: {
    setChartTheme() {
      if (this.theme == 'light') {
        this.options.series[0].axisTick.lineStyle = { color: 'rgba(11, 11, 11, 1)' };
        this.options.series[0].axisLabel.color = 'rgba(11, 11, 11, 1)';
      } else {
        this.options.series[0].axisTick.lineStyle = { color: 'rgba(255, 255, 255, 1)' };
        this.options.series[0].axisLabel.color = 'rgba(255, 255, 255, 1)';
      }
    },
    setChartHandler(val) {
      if (isEmpty(val)) {
        return;
      }
      this.weatherMsg = {
        temp: val.temp,
        humidity: val.humidity
      };
      if (val.windSpeedValue) {
        this.windLevel = val.windSpeedValue;
      }
      this.options.series[0].data[0].value = val.windDirection;
    }
  }
};
</script>
<style lang="scss" scoped>
.compass-view {
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .weather-info {
    margin-right: 20px;
    color: var(--drone-list-base-font-color);
    font-weight: 500;
  }
}
</style>
